module.exports = __webpack_public_path__ + "img/noimage-news-little.78a5a1f5.jpg";